export enum AuthServerEnvironment {
  LOCAL = 'LO',
  AUSTRALIA = 'AU',
  LIVE = 'IE',
  ROCKS = 'RO',
  SINGAPORE = 'SG',
  UK = 'UK',
}

// Regions where UK/EMEA-specific medical device regulation content (e.g. MDR information,
// UKCA certification) is relevant. Local/dev codes are included so non-prod environments
// keep the menu visible for QA/development.
export const EMEA_REGION_CODES: ReadonlySet<string> = new Set([
  AuthServerEnvironment.LIVE,
  AuthServerEnvironment.UK,
  AuthServerEnvironment.LOCAL,
  AuthServerEnvironment.ROCKS,
]);
